"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FavoriteFillSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { d: "M17.0806,7.8769 C16.9746,7.5499 16.6976,7.3149 16.3566,7.2659 L12.4576,6.7449 L10.6786,3.1409 C10.3746,2.5239 9.3746,2.5229 9.0706,3.1409 L7.3706,6.6879 L3.3926,7.2659 C3.0526,7.3149 2.7746,7.5499 2.6686,7.8769 C2.5626,8.2039 2.6496,8.5559 2.8956,8.7949 L5.7446,11.5089 L5.0646,15.4699 C5.0066,15.8089 5.1436,16.1449 5.4216,16.3469 C5.5796,16.4609 5.7626,16.5199 5.9476,16.5199 C6.0906,16.5199 6.2336,16.4849 6.3656,16.4149 L9.8276,14.5449 L13.3836,16.4149 C13.6876,16.5749 14.0496,16.5489 14.3276,16.3469 C14.6056,16.1449 14.7436,15.8089 14.6846,15.4699 L13.9766,11.6009 L16.8526,8.7959 C17.0996,8.5559 17.1866,8.2039 17.0806,7.8769", fillRule: "evenodd" })));
};
FavoriteFillSmall.displayName = 'FavoriteFillSmall';
exports.default = FavoriteFillSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FavoriteFillSmall.js.map